import React, { Component } from 'react';
import { Common } from '../../core/common';
import * as Actions from '../../store/actions/messages';
import { MessagesService } from '../../api/message-services';
import { SecureImage } from '../../components/core/secureImage';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import queryString from 'querystring';
import ReactGA from 'react-ga4';

const _lodash = require('lodash');

const T = Translator.create();

const _logger = Log.create('contactListItem.tsx');
let _common: Common;
const messagesService = new MessagesService();
let isRedirectedToMessage: boolean = false;

export class CContactListItem extends Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    componentDidMount(): void {
        isRedirectedToMessage = false;
    }
    openChat = (callType: Number) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_CONTACTS_X_MESSAGE_CLICKED',
            label:'G_CONTACTS_X_MESSAGE_CLICKED', 
            nonInteraction: true, 
          });
        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);

        let filteredUser: any = null;
        let filtereduserConversations: any = null;
        if (!_lodash.isEmpty(params.userId) || !_lodash.isEmpty(params.userName)) {
            if (this.props.message!.userConversations! && this.props.message!.userConversations!.length > 0) {
                filtereduserConversations = this.props.message!.userConversations!.filter((element: any) => _lodash.isEqual(element.userId, params.userId))[0];
            }

            if (filtereduserConversations == null && this.props.message!.users! && this.props.message!.users!.length > 0)
                filteredUser = this.props.message!.users!.filter((element: any) => _lodash.isEqual(element.userId, params.userId))[0];

            if (callType === 1 &&  
                filtereduserConversations == null &&
                this.props.message!.users! && this.props.message!.users!.length > 0 
            ) {
                filteredUser = {
                    userId: params.userId,
                    nameSurname: params.userName,
                    imageUrl: ""
                }
                // filtereduserConversations = this.props.message!.userConversations!.filter((element: any) => _lodash.isEqual(element.userName.replace(' ', '%20'), params.userName))[0];
                // if (filtereduserConversations == null)
                //     filteredUser = this.props.message!.users!.filter((element: any) => _lodash.isEqual(element.nameSurname.replace(' ', '%20'), params.userName))[0];
            }
        }
        
        if ((!_lodash.isEmpty(params.userName) || !_lodash.isEmpty(params.userId)) && filteredUser) {
            messagesService.RequestGetOriginMessageAsync(filteredUser.userId).then(data => {
                if (data && data.length > 0) {
                    this.props.dispatch(
                        Actions.getMessageListAction({
                            skip: 0,
                            take: 10,
                            originMessageId: data,
                            contextType: 0,
                            contextId: filteredUser.userId,
                            imageUrl: filteredUser.imageUrl,
                            chatTitleText: filteredUser.nameSurname,
                            spinnerId: 'getMessageListAction',
                            spinnerType: 'get',
                            callback: this.openChatCallBack
                        })
                    );
                } else {
                    this.props.dispatch(
                        Actions.setMessageListAction(
                            [],
                            '-1',
                            0,
                            100,
                            0,
                            filteredUser.nameSurname,
                            filteredUser.imageUrl,
                            filteredUser.userId,
                            0,
                            'getMessageListAction',
                            'set'
                        )
                    );
                }
            })
        } else if ((!_lodash.isEmpty(params.userName) || !_lodash.isEmpty(params.userId)) && filtereduserConversations) {
            messagesService.RequestGetOriginMessageAsync(filtereduserConversations.userId).then(data => {
                if (data && data.length > 0) {
                    this.props.dispatch(
                        Actions.getMessageListAction({
                            skip: 0,
                            take: 10,
                            originMessageId: data,
                            contextType: 0,
                            contextId: filtereduserConversations.userId,
                            imageUrl: filtereduserConversations.images[0],
                            chatTitleText: filtereduserConversations.userName,
                            spinnerId: 'getMessageListAction',
                            spinnerType: 'get',
                            callback: this.openChatCallBack
                        })
                    );
                } else {
                    this.props.dispatch(
                        Actions.setMessageListAction(
                            [],
                            '-1',
                            0,
                            100,
                            0,
                            filtereduserConversations.userName,
                            filtereduserConversations.images[0],
                            filtereduserConversations.userId,
                            0,
                            'getMessageListAction',
                            'set'
                        )
                    );
                }
            })
        } else {

            messagesService.RequestGetOriginMessageAsync(this.props.userId).then(data => {
                if (data && data.length > 0) {
                    this.props.dispatch(
                        Actions.getMessageListAction({
                            skip: 0,
                            take: 10,
                            originMessageId: data,
                            contextType: 0,
                            contextId: this.props.userId,
                            imageUrl: this.props.imageUrl,
                            chatTitleText: this.props.nameSurname,
                            spinnerId: 'getMessageListAction',
                            spinnerType: 'get',
                            callback: this.openChatCallBack
                        })
                    );
                } else {
                    this.props.dispatch(
                        Actions.setMessageListAction(
                            [],
                            '-1',
                            0,
                            100,
                            0,
                            this.props.nameSurname,
                            this.props.imageUrl,
                            this.props.userId,
                            0,
                            'getMessageListAction',
                            'set'
                        )
                    );
                    this.openChatCallBack()
                }
            });
        }

    };
    openChatCallBack = () => {
        const item = document.getElementById('chatPanel');
        const itemContactList = document.getElementById('chatContactList');
        const blankChatPanelText = document.getElementById('blankChatPanelText');
        if (item) {
            item.className = 'conversation-window relative mobile_chat_panel display_sm';
            if (itemContactList) {
                itemContactList.className = 'main-sidebar display_sm_none';
                if (blankChatPanelText) {
                    blankChatPanelText.className = 'create-announcement text-center display_sm_none';
                }
            }
        }
        if (itemContactList) {
            itemContactList.className = 'main-sidebar display_sm_none';
        }      
    }
    public render() {
        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);
        if ((params.userName || params.userId) && !isRedirectedToMessage) {
            this.openChat(1);
            isRedirectedToMessage = true;
        }

        return (
            <div className="media" onClick={e => this.openChat(0)}>
                <SecureImage imageUrl={this.props.imageUrl} key={this.props.imageUrl} imgType={'avatar'} onClick={this.openChat} />
                <div className="ml-1 media-body">
                    <span
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal'
                        }}>{this.props.nameSurname}</span>
                    {/*
                    <div className="chat-icon-group">
                        <div className="group-item" onClick={this.openChat}>
                            <a className="material-icons">chat_bubble_outline</a>
                        </div>
                        <div className="group-item">
                            <div className="dropdown">
                                <a className="material-icons" data-toggle="dropdown" href="javascript:;">
                                    more_horiz
                                </a>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a className="dropdown-item" href="javascript:void(0);" onClick={this.openChat}>
                                        {T.t('r_send_message')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>*/}
                </div>
            </div>
        );
    }
}

export default CContactListItem;
